var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCompleted(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 342.066,
    height: 381.14,
    viewBox: "0 0 342.066 381.14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Completed-pana",
    transform: "translate(-47.882 -24.52)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-8",
    transform: "translate(47.882 106.566)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M380.118,245.87l-61.562-23.277a8.228,8.228,0,0,1-4.782-10.615l32.216-85.2a8.236,8.236,0,0,1,10.615-4.791l39.047,14.762,18.436,42.576-23.354,61.791A8.236,8.236,0,0,1,380.118,245.87Z",
    transform: "translate(-88.627 -121.449)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M408.863,139.52,399.79,163.5a7.66,7.66,0,0,0,4.452,9.878L427.3,182.1Z",
    transform: "translate(-101.841 -124.224)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M399.215,170.48s-2.5,5.705,3.386,10.157a7,7,0,0,0,.694.457c2.81,1.693,21.3,12.7,21.466,12.248l2.438-6.45-23.057-8.718S398.47,175.762,399.215,170.48Z",
    transform: "translate(-101.748 -128.978)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M389.054,162.435c-.119.313-6.585-1.854-14.449-4.825s-14.144-5.637-14.026-5.925,6.585,1.854,14.449,4.825S389.173,162.105,389.054,162.435Z",
    transform: "translate(-95.896 -126.088)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M401.388,185.41c-.119.3-10.7-3.386-23.641-8.3s-23.345-9.116-23.227-9.429,10.7,3.386,23.65,8.312S401.481,185.1,401.388,185.41Z",
    transform: "translate(-94.966 -128.545)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M400.552,200.382c-.119.3-11.647-3.767-25.758-9.108s-25.453-9.912-25.334-10.217,11.647,3.767,25.757,9.108S400.7,200.068,400.552,200.382Z",
    transform: "translate(-94.189 -130.6)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M395.782,213c-.119.3-11.647-3.767-25.758-9.108s-25.453-9.946-25.334-10.217,11.647,3.767,25.758,9.1S395.9,212.689,395.782,213Z",
    transform: "translate(-93.457 -132.538)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M391.01,225.622c-.118.3-11.656-3.767-25.757-9.108S339.8,206.6,339.91,206.3s11.647,3.767,25.766,9.1S391.12,225.308,391.01,225.622Z",
    transform: "translate(-92.723 -134.475)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    d: "M386.232,238.242c-.11.3-11.647-3.775-25.749-9.108s-25.461-9.912-25.343-10.217,11.647,3.767,25.757,9.1S386.35,237.928,386.232,238.242Z",
    transform: "translate(-91.99 -136.413)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_363",
    "data-name": "Rectangle 363",
    width: 96.758,
    height: 133.968,
    rx: 6.36,
    transform: "matrix(0.944, -0.331, 0.331, 0.944, 0, 66.165)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_364",
    "data-name": "Rectangle 364",
    width: 83.181,
    height: 122.109,
    transform: "matrix(0.944, -0.331, 0.331, 0.944, 8.774, 70.684)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_365",
    "data-name": "Rectangle 365",
    width: 83.181,
    height: 119.781,
    transform: "matrix(0.944, -0.331, 0.331, 0.944, 7.369, 70.142)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    d: "M174.653,284.868l-39.69-113.01.144.068-78.491,27.5h0l.076-.152c14.8,42.458,28.568,81.674,39.563,113.052l-.127-.059,78.534-27.4-78.474,27.6h-.093v-.093C85.09,281,71.361,241.784,56.48,199.334v-.119h.11l78.5-27.476h.11v.1Z",
    transform: "translate(-49.202 -129.171)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    d: "M163.2,311.45s17.479-14.745,20.51-30.1a22.219,22.219,0,0,1-14.948,9.015S168.414,306.447,163.2,311.45Z",
    transform: "translate(-65.589 -146.002)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_366",
    "data-name": "Rectangle 366",
    width: 10.166,
    height: 10.166,
    rx: 3.42,
    transform: "matrix(0.944, -0.331, 0.331, 0.944, 27.335, 97.735)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    d: "M87.3,241.589h0a.2.2,0,0,1-.186,0l-1.9-1.1a.237.237,0,0,1,.237-.406l1.693.965,2-4.232a.254.254,0,0,1,.322-.118.237.237,0,0,1,.11.322l-2.108,4.5A.22.22,0,0,1,87.3,241.589Z",
    transform: "translate(-53.6 -139.142)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    d: "M143.455,213.4c0,.068-10.157,3.7-22.761,8.109S97.84,229.44,97.84,229.381s10.157-3.7,22.77-8.109S143.438,213.341,143.455,213.4Z",
    transform: "translate(-55.553 -135.568)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    "data-name": "Path 15",
    d: "M119.972,232.62s-.262.118-.736.3l-2.048.762c-1.693.626-4.131,1.481-6.772,2.412s-5.079,1.761-6.772,2.345l-2.074.686a5.467,5.467,0,0,1-.77.22,4.992,4.992,0,0,1,.736-.313l2.048-.753c1.693-.635,4.131-1.49,6.772-2.421s5.079-1.752,6.772-2.345l2.074-.686a4.639,4.639,0,0,1,.77-.212Z",
    transform: "translate(-56.008 -138.519)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    "data-name": "Path 16",
    d: "M144.724,217.08c0,.059-10.157,3.691-22.77,8.1S99.1,233.12,99.1,233.052s10.157-3.691,22.778-8.1S144.724,217.012,144.724,217.08Z",
    transform: "translate(-55.747 -136.133)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_367",
    "data-name": "Rectangle 367",
    width: 10.166,
    height: 10.166,
    rx: 3.42,
    transform: "matrix(0.944, -0.331, 0.331, 0.944, 33.231, 114.578)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    "data-name": "Path 17",
    d: "M94.261,261.481h0a.22.22,0,0,1-.195,0l-1.888-1.1a.235.235,0,1,1,.237-.406l1.693.965,2-4.275a.245.245,0,0,1,.313-.118.237.237,0,0,1,.118.313l-2.108,4.512A.246.246,0,0,1,94.261,261.481Z",
    transform: "translate(-54.666 -142.191)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18",
    "data-name": "Path 18",
    d: "M150.424,233.3c0,.068-10.157,3.691-22.77,8.109S104.8,249.34,104.8,249.281s10.157-3.7,22.77-8.109S150.407,233.241,150.424,233.3Z",
    transform: "translate(-56.622 -138.624)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19",
    "data-name": "Path 19",
    d: "M126.942,252.52s-.262.118-.745.3l-2.04.762c-1.693.626-4.131,1.481-6.772,2.412s-5.079,1.761-6.772,2.345l-2.074.686a5.469,5.469,0,0,1-.77.22,4.5,4.5,0,0,1,.736-.313l2.048-.753c1.693-.635,4.131-1.49,6.772-2.421s5.079-1.752,6.772-2.345l2.074-.686a4.64,4.64,0,0,1,.77-.212Z",
    transform: "translate(-57.078 -141.575)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20",
    "data-name": "Path 20",
    d: "M151.724,237c0,.059-10.157,3.691-22.77,8.1s-22.854,7.94-22.854,7.872,10.157-3.691,22.77-8.1S151.724,236.915,151.724,237Z",
    transform: "translate(-56.821 -139.192)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_368",
    "data-name": "Rectangle 368",
    width: 10.166,
    height: 10.166,
    rx: 3.42,
    transform: "matrix(0.944, -0.331, 0.331, 0.944, 39.135, 131.42)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21",
    "data-name": "Path 21",
    d: "M101.225,281.382h0a.22.22,0,0,1-.195,0l-1.9-1.083a.237.237,0,1,1,.237-.406l1.693.965,2-4.275a.237.237,0,1,1,.432.195l-2.108,4.512a.279.279,0,0,1-.161.093Z",
    transform: "translate(-55.73 -145.247)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22",
    "data-name": "Path 22",
    d: "M157.394,253.2c0,.068-10.157,3.691-22.77,8.109s-22.854,7.931-22.854,7.864,10.157-3.691,22.778-8.1S157.368,253.141,157.394,253.2Z",
    transform: "translate(-57.692 -141.679)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23",
    "data-name": "Path 23",
    d: "M133.911,272.41a5.467,5.467,0,0,1-.745.313l-2.048.762c-1.693.626-4.122,1.481-6.772,2.412s-5.079,1.752-6.772,2.345l-2.074.686a5.863,5.863,0,0,1-.77.22,4.5,4.5,0,0,1,.736-.313l2.048-.762c1.693-.626,4.131-1.481,6.772-2.412s5.079-1.752,6.772-2.345l2.065-.686a7.216,7.216,0,0,1,.787-.22Z",
    transform: "translate(-58.147 -144.629)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24",
    "data-name": "Path 24",
    d: "M158.724,256.88c0,.059-10.157,3.691-22.77,8.1s-22.854,7.94-22.854,7.872,10.157-3.69,22.77-8.109S158.664,256.812,158.724,256.88Z",
    transform: "translate(-57.896 -142.244)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_369",
    "data-name": "Rectangle 369",
    width: 10.166,
    height: 10.166,
    rx: 3.42,
    transform: "matrix(0.944, -0.331, 0.331, 0.944, 45.031, 148.263)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25",
    "data-name": "Path 25",
    d: "M108.191,301.289h0a.237.237,0,0,1-.186,0l-1.9-1.1a.237.237,0,1,1,.245-.406l1.693.965,2-4.232a.237.237,0,0,1,.313-.119.246.246,0,0,1,.119.313l-2.116,4.512A.245.245,0,0,1,108.191,301.289Z",
    transform: "translate(-56.805 -148.309)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26",
    "data-name": "Path 26",
    d: "M164.364,273.1c0,.068-10.157,3.691-22.77,8.1s-22.854,7.94-22.854,7.872,10.157-3.691,22.77-8.1S164.338,273.015,164.364,273.1Z",
    transform: "translate(-58.762 -144.735)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27",
    "data-name": "Path 27",
    d: "M140.872,292.31a4.5,4.5,0,0,1-.736.313l-2.048.762c-1.693.626-4.131,1.481-6.772,2.412s-5.079,1.752-6.772,2.345l-2.074.686c-.491.152-.77.229-.77.22a4.5,4.5,0,0,1,.736-.313l2.048-.762c1.693-.626,4.131-1.481,6.772-2.412s5.079-1.752,6.772-2.345l2.074-.686a5.863,5.863,0,0,1,.77-.22Z",
    transform: "translate(-59.217 -147.685)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28",
    "data-name": "Path 28",
    d: "M165.654,276.78c0,.059-10.157,3.691-22.77,8.1s-22.854,7.931-22.854,7.872,10.157-3.691,22.77-8.109S165.628,276.712,165.654,276.78Z",
    transform: "translate(-58.96 -145.3)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29",
    "data-name": "Path 29",
    d: "M67.09,187.748l2.065,5.925a6.594,6.594,0,0,0,8.4,4.046l43.423-15.236a6.577,6.577,0,0,0,4.038-8.388l-2.065-5.925Z",
    transform: "translate(-50.832 -128.623)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30",
    "data-name": "Path 30",
    d: "M99.277,179.641a6.179,6.179,0,1,1,3.784-7.864,6.179,6.179,0,0,1-3.784,7.864Zm-3.3-9.421a3.809,3.809,0,1,0,4.85,2.336,3.809,3.809,0,0,0-4.85-2.336Z",
    transform: "translate(-54.51 -128.541)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31",
    "data-name": "Path 31",
    d: "M132.466,200c0,.11-11.41,4.232-25.571,9.184s-25.673,8.888-25.715,8.778,11.41-4.232,25.571-9.184S132.424,199.855,132.466,200Z",
    transform: "translate(-52.995 -133.51)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32",
    "data-name": "Path 32",
    d: "M120.331,202.449c0,.11-4.994,1.981-11.249,4.173s-11.359,3.911-11.4,3.758,5-1.981,11.258-4.173S120.3,202.339,120.331,202.449Z",
    transform: "translate(-55.529 -133.886)",
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plants--inject-8",
    transform: "translate(76.863 305.624)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33",
    "data-name": "Path 33",
    d: "M390.332,404.8a16.083,16.083,0,0,1,10-1.21,8.306,8.306,0,0,1,4.935,2.2c1.227,1.354,1.473,3.758.051,4.926a4.7,4.7,0,0,1-3.132.787c-2.649,0-5.578-.5-7.686,1.092-1.21.906-2.006,2.412-3.445,2.861a3.386,3.386,0,0,1-3.75-1.693,5.832,5.832,0,0,1-.423-4.292,6.552,6.552,0,0,1,3.453-4.672Z",
    transform: "translate(-128.88 -363.782)",
    fill: "#5796ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34",
    "data-name": "Path 34",
    d: "M382.4,384.208c1.862,2.649,5.477,1.778,7.153.152s2.379-3.97,3.022-6.2c1.473-5.121,2.963-10.488,1.871-15.7a8.752,8.752,0,0,0-2.006-4.232,4.562,4.562,0,0,0-4.317-1.439c-1.828.483-2.954,2.268-3.775,3.961a37.437,37.437,0,0,0-3.7,16.083c0,2.59.3,5.3,1.752,7.44",
    transform: "translate(-127.959 -356.629)",
    fill: "#5796ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35",
    "data-name": "Path 35",
    d: "M372.81,389.563a9.658,9.658,0,0,0,1.507-8.9,17.149,17.149,0,0,0-5.265-7.618,28.348,28.348,0,0,0-9.429-5.561,10.03,10.03,0,0,0-4.232-.719,4.435,4.435,0,0,0-3.555,2.15c-1,1.9,0,4.19.982,6.061a71,71,0,0,0,6.2,9.43c1.854,2.4,3.978,4.757,6.814,5.841s5.764.948,7.263-1.007",
    transform: "translate(-123.471 -358.174)",
    fill: "#5796ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36",
    "data-name": "Path 36",
    d: "M382.571,432.082a6.162,6.162,0,0,0,.161-1.2c.093-.846.195-1.981.322-3.293a46.069,46.069,0,0,1,.745-4.833,37.021,37.021,0,0,1,1.752-5.7,21.053,21.053,0,0,1,2.912-5.155,10.886,10.886,0,0,1,3.682-3.064,10.242,10.242,0,0,1,3.1-.965,5.821,5.821,0,0,0,1.2-.169,5.728,5.728,0,0,0-1.227,0,9.514,9.514,0,0,0-3.225.846,10.826,10.826,0,0,0-3.885,3.081,20.687,20.687,0,0,0-3.013,5.265,34.211,34.211,0,0,0-1.744,5.79,41.343,41.343,0,0,0-.643,4.892c-.11,1.4-.144,2.539-.161,3.31a5.079,5.079,0,0,0,.025,1.194Z",
    transform: "translate(-128.246 -364.457)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37",
    "data-name": "Path 37",
    d: "M382.8,423.644a2.067,2.067,0,0,0,0-.559v-1.574c0-1.388,0-3.386.068-5.925.127-4.969.55-10.31,1.38-17.843.779-7.085,1.828-15.329,2.937-20.687.237-1.219.474-2.319.7-3.276s.4-1.794.576-2.463.271-1.151.372-1.557a4.224,4.224,0,0,0,.1-.559,2.422,2.422,0,0,0-.195.525c-.127.406-.279.914-.466,1.541s-.423,1.49-.66,2.446-.516,2.048-.779,3.267a184.007,184.007,0,0,0-3.056,19.214,189.337,189.337,0,0,0-1.227,19.4c0,2.489,0,4.5.085,5.925,0,.652.068,1.185.093,1.6A3.006,3.006,0,0,0,382.8,423.644Z",
    transform: "translate(-128.251 -358.549)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38",
    "data-name": "Path 38",
    d: "M379.659,411.125a10.155,10.155,0,0,0,0-1.693,45.309,45.309,0,0,0-.516-4.529,58.4,58.4,0,0,0-1.473-6.6,53.438,53.438,0,0,0-2.759-7.813,41.7,41.7,0,0,0-8.1-12.621A20.641,20.641,0,0,0,364.9,376.1a7.806,7.806,0,0,0-.846-.694l-.736-.508a9.445,9.445,0,0,0-1.414-.9,47.572,47.572,0,0,1,4.613,4.114,43.508,43.508,0,0,1,7.906,12.578,61.305,61.305,0,0,1,2.776,7.737,63.546,63.546,0,0,1,1.566,6.535c.347,1.888.55,3.386.669,4.486a11.519,11.519,0,0,0,.229,1.676Z",
    transform: "translate(-125.08 -359.286)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39",
    "data-name": "Path 39",
    d: "M367.74,445.49l1.329,18.2h23.387l1.32-18.2Z",
    transform: "translate(-125.977 -370.264)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_370",
    "data-name": "Rectangle 370",
    width: 31.09,
    height: 7.178,
    transform: "translate(239.512 68.048)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40",
    "data-name": "Path 40",
    d: "M365.08,466.17v1.981h30.565V466.17Z",
    transform: "translate(-125.568 -373.439)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41",
    "data-name": "Path 41",
    d: "M368.23,472.014l-1.43-3.5h28l-1.676,3.5Z",
    transform: "translate(-125.832 -373.798)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42",
    "data-name": "Path 42",
    d: "M393.429,452.049s0,.068-.11.169l-.347.466-1.363,1.744-.059.076-.059-.085-3.343-4.622h.2l-3.3,4.664-.1.144-.119-.135-3.9-4.655h.22l-.212.271-3.5,4.376-.11.152-.11-.152c-1.185-1.693-2.294-3.25-3.3-4.664h.195l-4.055,4.622-.076.085-.059-.093c-.533-.9-.957-1.617-1.27-2.133l-.322-.567a.845.845,0,0,1-.1-.2,1.282,1.282,0,0,1,.135.178l.364.55,1.329,2.091h-.127l4-4.681.1-.119.093.127,3.327,4.647h-.229l3.513-4.376.22-.271.11-.144.11.135,3.9,4.664h-.22l3.327-4.647.093-.135.1.135c1.312,1.888,2.438,3.487,3.276,4.681h-.127l1.422-1.693.381-.44Z",
    transform: "translate(-126.052 -370.881)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43",
    "data-name": "Path 43",
    d: "M394.142,445.314c0,.085-5.857.152-13.086.152s-13.086-.068-13.086-.152,5.857-.144,13.086-.144S394.142,445.238,394.142,445.314Z",
    transform: "translate(-126.012 -370.215)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44",
    "data-name": "Path 44",
    d: "M395.131,468.722c0,.076-6.374.144-14.22.144s-14.22-.068-14.22-.144,6.365-.152,14.22-.152S395.131,468.638,395.131,468.722Z",
    transform: "translate(-125.815 -373.808)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45",
    "data-name": "Path 45",
    d: "M127.409,399.834c-.068.076-.6-.245-1.193-.719s-1.024-.923-.956-1.007.593.245,1.185.719S127.468,399.75,127.409,399.834Z",
    transform: "translate(-88.743 -362.986)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46",
    "data-name": "Path 46",
    d: "M143.837,369.437a18.521,18.521,0,0,0-.55-6.729,6.637,6.637,0,0,0-4.588-4.6c-2.539-.525-5.129,1.075-6.552,3.242a18.713,18.713,0,0,0-2.328,7.339,259.353,259.353,0,0,0-3.174,53.284l10.361,1.456C141.517,404.836,142.99,388.576,143.837,369.437Z",
    transform: "translate(-88.919 -356.831)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47",
    "data-name": "Path 47",
    d: "M137.81,358l-.051.169-.169.466-.694,1.794c-.144.389-.339.846-.491,1.3l-.5,1.566-.584,1.8-.533,2.057a89.723,89.723,0,0,0-2.006,10.318c-.559,3.894-.923,8.211-1.219,12.748-.525,9.082-.609,17.327-.846,23.286-.11,2.988-.212,5.4-.322,7.059-.059.846-.1,1.447-.135,1.921v-.008c0-.466,0-1.109.059-1.921.068-1.693.127-4.071.2-7.059.169-5.925.212-14.2.745-23.294.288-4.545.669-8.871,1.244-12.781a85.293,85.293,0,0,1,2.091-10.276l.559-2.057q.33-.948.609-1.8l.542-1.566c.161-.474.364-.9.516-1.287l.762-1.761q.119-.279.2-.457a.643.643,0,0,1,.017-.212Z",
    transform: "translate(-89.512 -356.83)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48",
    "data-name": "Path 48",
    d: "M139.877,358.05a7.474,7.474,0,0,1,1.27,2.142,15.854,15.854,0,0,1,.94,6.7c-.271,5.73-.787,13.619-1.464,22.338s-1.447,16.59-2.057,22.287c-.313,2.844-.576,5.146-.77,6.772-.1.77-.178,1.38-.237,1.828l-.068.474a1.1,1.1,0,0,1,0,.161v-.643c0-.449.093-1.058.161-1.837.161-1.625.381-3.919.652-6.772.542-5.705,1.261-13.543,1.947-22.3s1.236-16.6,1.574-22.312a16.184,16.184,0,0,0-.846-6.645A13.9,13.9,0,0,0,139.877,358.05Z",
    transform: "translate(-90.622 -356.837)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49",
    "data-name": "Path 49",
    d: "M148.111,389.494a5.645,5.645,0,0,1-1.964-.508,5.74,5.74,0,0,1-1.837-.846,5.426,5.426,0,0,1,1.964.508A5.646,5.646,0,0,1,148.111,389.494Z",
    transform: "translate(-91.669 -361.458)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50",
    "data-name": "Path 50",
    d: "M149.574,377.26A6.467,6.467,0,0,1,147.7,378.3a6.272,6.272,0,0,1-2.023.7A12.35,12.35,0,0,1,149.574,377.26Z",
    transform: "translate(-91.88 -359.787)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51",
    "data-name": "Path 51",
    d: "M148.954,367.008a6.264,6.264,0,0,1-3.064-.212,6.567,6.567,0,0,1,3.064.212Z",
    transform: "translate(-91.912 -358.16)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52",
    "data-name": "Path 52",
    d: "M136.56,360.055c-.085.051-.542-.516-1.007-1.261a3.733,3.733,0,0,1-.7-1.464c.085-.051.542.508,1.016,1.261S136.67,360,136.56,360.055Z",
    transform: "translate(-90.217 -356.726)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_53",
    "data-name": "Path 53",
    d: "M132.167,366.665a3.089,3.089,0,0,1-1.473.152,3.055,3.055,0,0,1-1.464-.22,3.089,3.089,0,0,1,1.473-.152A3.056,3.056,0,0,1,132.167,366.665Z",
    transform: "translate(-89.354 -358.122)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_54",
    "data-name": "Path 54",
    d: "M129.163,378.783a3.571,3.571,0,0,1-1.549-.423,3.657,3.657,0,0,1-1.414-.77,3.572,3.572,0,0,1,1.549.423,3.657,3.657,0,0,1,1.414.77Z",
    transform: "translate(-88.888 -359.838)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55",
    "data-name": "Path 55",
    d: "M128.887,389.383a2.787,2.787,0,0,1-1.32.466c-.753.152-1.371.212-1.4.11s.576-.313,1.32-.466A2.861,2.861,0,0,1,128.887,389.383Z",
    transform: "translate(-88.884 -361.642)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_56",
    "data-name": "Path 56",
    d: "M127.479,406.34a3.145,3.145,0,0,1-1.405.44,3.048,3.048,0,0,1-1.464.068,3.1,3.1,0,0,1,1.405-.432A2.988,2.988,0,0,1,127.479,406.34Z",
    transform: "translate(-88.644 -364.243)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57",
    "data-name": "Path 57",
    d: "M126.545,415.706c.051.085-.474.457-1.168.846s-1.3.593-1.337.5.474-.457,1.168-.846S126.545,415.613,126.545,415.706Z",
    transform: "translate(-88.556 -365.687)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_58",
    "data-name": "Path 58",
    d: "M134.36,425.786c-.085.051-.542-.576-1.016-1.405a4.08,4.08,0,0,1-.694-1.591c.085-.051.542.576,1.016,1.405a4.08,4.08,0,0,1,.694,1.591Z",
    transform: "translate(-89.879 -366.778)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_59",
    "data-name": "Path 59",
    d: "M136.42,408.679c.068.068-.44.686-1.134,1.371s-1.32,1.177-1.4,1.1.44-.686,1.134-1.371S136.343,408.6,136.42,408.679Z",
    transform: "translate(-90.068 -364.61)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_60",
    "data-name": "Path 60",
    d: "M136.057,399.052c-.076.076-.542-.313-1.05-.846s-.846-1.05-.779-1.117.542.313,1.05.846S136.133,398.985,136.057,399.052Z",
    transform: "translate(-90.12 -362.831)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61",
    "data-name": "Path 61",
    d: "M137.515,387.579c.076.068-.347.669-.948,1.329s-1.143,1.16-1.219,1.092.347-.669.94-1.337S137.439,387.511,137.515,387.579Z",
    transform: "translate(-90.292 -361.37)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62",
    "data-name": "Path 62",
    d: "M138.327,378.575c-.076.076-.66-.389-1.32-1.033s-1.126-1.227-1.058-1.3.66.389,1.32,1.041S138.4,378.5,138.327,378.575Z",
    transform: "translate(-90.384 -359.629)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_63",
    "data-name": "Path 63",
    d: "M140.139,367.379a3.716,3.716,0,0,1-.669,1.473c-.449.762-.889,1.337-.973,1.287a3.622,3.622,0,0,1,.66-1.473C139.615,367.9,140.046,367.329,140.139,367.379Z",
    transform: "translate(-90.774 -358.269)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64",
    "data-name": "Path 64",
    d: "M143.318,356.62c.093.051-.169.711-.584,1.473a4.029,4.029,0,0,1-.914,1.3,3.529,3.529,0,0,1,.584-1.473C142.819,357.153,143.225,356.577,143.318,356.62Z",
    transform: "translate(-91.287 -356.617)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65",
    "data-name": "Path 65",
    d: "M146.8,361.5c.042.093-.372.381-.931.652s-1.041.406-1.083.313.372-.381.931-.652S146.762,361.412,146.8,361.5Z",
    transform: "translate(-91.742 -357.363)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_66",
    "data-name": "Path 66",
    d: "M146.564,399.857a6.331,6.331,0,0,1-3.784-1.617,10.528,10.528,0,0,1,1.9.787A10.049,10.049,0,0,1,146.564,399.857Z",
    transform: "translate(-91.434 -363.009)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67",
    "data-name": "Path 67",
    d: "M145.271,408.32a3.1,3.1,0,0,1-1.4.457,3,3,0,0,1-1.464.093,3.175,3.175,0,0,1,1.4-.457C144.6,408.261,145.254,408.218,145.271,408.32Z",
    transform: "translate(-91.377 -364.548)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_68",
    "data-name": "Path 68",
    d: "M143.535,421.773c-.059.085-.846-.466-1.574-1.38a4.122,4.122,0,0,1-.99-1.854,11.73,11.73,0,0,1,1.278,1.625,11.2,11.2,0,0,1,1.287,1.608Z",
    transform: "translate(-91.156 -366.126)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69",
    "data-name": "Path 69",
    d: "M124.309,428.449c-.068-.076.356-.55.94-1.05s1.117-.846,1.185-.762-.356.542-.94,1.05S124.376,428.525,124.309,428.449Z",
    transform: "translate(-88.597 -367.367)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_70",
    "data-name": "Path 70",
    d: "M117.178,397.326c-.677-2.108-1.938-4.562-4.148-4.6a3.674,3.674,0,0,0-3.115,2.082,7.618,7.618,0,0,0-.846,3.809,99.509,99.509,0,0,0,4.749,27.611h8.1a96.385,96.385,0,0,0-4.74-28.906Z",
    transform: "translate(-86.257 -362.162)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71",
    "data-name": "Path 71",
    d: "M98.83,381.185a8.989,8.989,0,0,0-8.465-7.195c-3.58.626-4.969,4.148-5.392,7.753s.694,7.195,1.8,10.657q5.316,16.658,10.648,33.325l10.073-1.1C104.349,409.744,102.52,395.947,98.83,381.185Z",
    transform: "translate(-82.544 -359.285)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72",
    "data-name": "Path 72",
    d: "M113.5,392.73a7.547,7.547,0,0,0-.686,1.143,7.457,7.457,0,0,0-.381,3.581c.152,1.541.33,3.386.593,5.417s.626,4.232,1.083,6.585c.914,4.655,1.947,8.82,2.6,11.85.33,1.515.584,2.751.736,3.606.068.4.127.719.169.99s.051.347,0,.347a1.869,1.869,0,0,1-.1-.33l-.237-.973c-.22-.906-.508-2.116-.846-3.58-.719-3.03-1.794-7.186-2.709-11.85-.457-2.336-.846-4.571-1.058-6.619-.135-1.016-.22-2-.3-2.9s-.169-1.761-.212-2.539a7.347,7.347,0,0,1,.508-3.657,3.166,3.166,0,0,1,.846-1.067Z",
    transform: "translate(-86.722 -362.162)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73",
    "data-name": "Path 73",
    d: "M91.031,373.65a12.875,12.875,0,0,0-1.219,1.634,11.554,11.554,0,0,0-1.532,5.273,24.547,24.547,0,0,0,1.244,8.1c.846,3,1.854,6.289,2.878,9.734,2.006,6.907,3.817,13.154,5.146,17.716l1.524,5.383c.169.609.3,1.092.4,1.464a2.428,2.428,0,0,1,.11.516,2.742,2.742,0,0,1-.186-.491c-.11-.372-.271-.846-.457-1.456-.4-1.3-.956-3.115-1.634-5.341l-5.256-17.691c-1.016-3.462-1.972-6.772-2.853-9.751a24.174,24.174,0,0,1-1.177-8.211,11.317,11.317,0,0,1,1.693-5.333,6.188,6.188,0,0,1,1.32-1.549Z",
    transform: "translate(-83.024 -359.233)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74",
    "data-name": "Path 74",
    d: "M106.252,423.534a4.719,4.719,0,0,1-.229-.482c-.127-.33-.339-.8-.567-1.422a48.4,48.4,0,0,1-1.693-5.341c-.593-2.285-1.27-5.079-1.879-8.126s-1.219-6.458-1.9-10.013a97.063,97.063,0,0,0-2.379-9.887,56.012,56.012,0,0,0-2.937-7.762,41.724,41.724,0,0,0-2.717-4.892c-.347-.559-.66-.973-.846-1.261a3.125,3.125,0,0,1-.279-.457,3.125,3.125,0,0,1,.339.406c.212.288.542.677.906,1.236a35.991,35.991,0,0,1,2.836,4.859,51.874,51.874,0,0,1,3.022,7.77,98.009,98.009,0,0,1,2.353,9.92c.669,3.547,1.3,6.932,1.871,10.022s1.185,5.824,1.794,8.117,1.177,4.114,1.617,5.358c.2.635.4,1.109.508,1.439a2.429,2.429,0,0,1,.178.516Z",
    transform: "translate(-83.457 -359.27)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75",
    "data-name": "Path 75",
    d: "M86.921,393.771a2.694,2.694,0,0,1-1.227.482c-.7.169-1.287.229-1.3.127s.516-.313,1.219-.482S86.9,393.669,86.921,393.771Z",
    transform: "translate(-82.468 -362.315)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_76",
    "data-name": "Path 76",
    d: "M85.506,385.62a5.2,5.2,0,0,1-1.693.186,5,5,0,0,1-1.693-.051,5.784,5.784,0,0,1,3.386-.135Z",
    transform: "translate(-82.12 -361.037)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77",
    "data-name": "Path 77",
    d: "M87.06,377.9c-.068.085-.618-.271-1.219-.787s-1.05-1-.982-1.075.609.271,1.219.787S87.127,377.824,87.06,377.9Z",
    transform: "translate(-82.539 -359.598)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78",
    "data-name": "Path 78",
    d: "M91.033,371.38c.1,0,.068.516.059,1.1s0,1.083-.127,1.1-.262-.474-.245-1.109S90.957,371.354,91.033,371.38Z",
    transform: "translate(-83.44 -358.884)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79",
    "data-name": "Path 79",
    d: "M98.244,374.609c.085.059-.161.559-.55,1.109s-.77.956-.846.9.161-.55.542-1.109S98.159,374.55,98.244,374.609Z",
    transform: "translate(-84.379 -359.379)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80",
    "data-name": "Path 80",
    d: "M102.863,382.993a2.79,2.79,0,0,1-1.16.677c-.677.279-1.27.423-1.3.33s.482-.4,1.16-.669S102.829,382.875,102.863,382.993Z",
    transform: "translate(-84.927 -360.662)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_81",
    "data-name": "Path 81",
    d: "M105.625,391.57a2.954,2.954,0,0,1-1.591.7,3.166,3.166,0,0,1-1.744.059,6.6,6.6,0,0,1,1.693-.423,6.906,6.906,0,0,1,1.642-.339Z",
    transform: "translate(-85.217 -361.984)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_82",
    "data-name": "Path 82",
    d: "M92.823,388.743c-.093,0,0-.533.161-1.126s.415-1.041.508-1.007,0,.533-.161,1.126S92.967,388.777,92.823,388.743Z",
    transform: "translate(-83.758 -361.222)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_83",
    "data-name": "Path 83",
    d: "M94.7,399.408a3.487,3.487,0,0,1,.457-1.515c.347-.8.7-1.405.8-1.363a3.487,3.487,0,0,1-.457,1.515C95.149,398.84,94.793,399.467,94.7,399.408Z",
    transform: "translate(-84.052 -362.746)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_84",
    "data-name": "Path 84",
    d: "M89.569,402.725a3.834,3.834,0,0,1-1.447-.322c-.77-.245-1.4-.466-1.371-.567a2.811,2.811,0,0,1,1.481.212C89.018,402.293,89.611,402.632,89.569,402.725Z",
    transform: "translate(-82.831 -363.557)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85",
    "data-name": "Path 85",
    d: "M92.351,411.687c.059.085-.372.491-.956.914s-1.126.694-1.185.618.372-.5.965-.923S92.291,411.6,92.351,411.687Z",
    transform: "translate(-83.361 -365.071)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_86",
    "data-name": "Path 86",
    d: "M94.431,420.461a2.506,2.506,0,0,1-1.193.474c-.686.161-1.253.22-1.278.127s.508-.313,1.193-.482S94.406,420.359,94.431,420.461Z",
    transform: "translate(-83.631 -366.412)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87",
    "data-name": "Path 87",
    d: "M106.046,398.906c.051.085-.406.449-1.067.694s-1.253.279-1.27.186.508-.288,1.134-.533S106,398.813,106.046,398.906Z",
    transform: "translate(-85.435 -363.107)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_88",
    "data-name": "Path 88",
    d: "M107.708,412.362c-.042.093-.584-.068-1.21-.364s-1.1-.609-1.058-.7.593.076,1.219.364S107.759,412.269,107.708,412.362Z",
    transform: "translate(-85.7 -365.009)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_89",
    "data-name": "Path 89",
    d: "M110.492,422.12a3.962,3.962,0,0,1-1.608-.432c-.846-.33-1.5-.677-1.464-.779a3.935,3.935,0,0,1,1.6.432C109.866,421.672,110.526,422.019,110.492,422.12Z",
    transform: "translate(-86.005 -366.489)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90",
    "data-name": "Path 90",
    d: "M95.35,429.6c-.051-.093.609-.533,1.371-1.134s1.354-1.143,1.431-1.067-.406.728-1.2,1.354a3.259,3.259,0,0,1-1.6.846Z",
    transform: "translate(-84.151 -367.485)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91",
    "data-name": "Path 91",
    d: "M102.9,424.563c-.1,0-.245-.542-.5-1.185s-.508-1.16-.423-1.219.508.381.77,1.083S103,424.563,102.9,424.563Z",
    transform: "translate(-85.166 -366.68)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_92",
    "data-name": "Path 92",
    d: "M100.695,413.048c-.059.085-.482-.118-.948-.449s-.787-.669-.728-.753.482.119.948.449S100.779,412.964,100.695,413.048Z",
    transform: "translate(-84.714 -365.095)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_93",
    "data-name": "Path 93",
    d: "M118.626,394.847c.059.085-.356.491-.923.906s-1.075.694-1.134.609.347-.482.914-.906S118.626,394.763,118.626,394.847Z",
    transform: "translate(-87.409 -362.485)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_94",
    "data-name": "Path 94",
    d: "M121.242,402.209c0,.1-.635.237-1.431.152s-1.4-.356-1.371-.449a4.392,4.392,0,0,1,1.414.076C120.615,402.065,121.233,402.108,121.242,402.209Z",
    transform: "translate(-87.697 -363.566)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_95",
    "data-name": "Path 95",
    d: "M109.586,403.929a2.325,2.325,0,0,1-1.346.356c-.779.051-1.388-.076-1.38-.178s.618-.135,1.363-.186S109.569,403.827,109.586,403.929Z",
    transform: "translate(-85.919 -363.872)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_96",
    "data-name": "Path 96",
    d: "M110.682,396.729c0,.1-.609.119-1.27-.195s-1.041-.762-.973-.846.525.237,1.126.508S110.69,396.627,110.682,396.729Z",
    transform: "translate(-86.16 -362.614)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_97",
    "data-name": "Path 97",
    d: "M122.285,409.942c-.051.085-.669-.2-1.38-.652s-1.236-.846-1.177-.965.669.212,1.38.652S122.345,409.858,122.285,409.942Z",
    transform: "translate(-87.894 -364.553)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_371",
    "data-name": "Rectangle 371",
    width: 52.692,
    height: 9.336,
    transform: "translate(5.798 63.012)",
    fill: "#5796ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_98",
    "data-name": "Path 98",
    d: "M93.62,439.91l6.408,27.908h31.4l7.009-27.908Z",
    transform: "translate(-83.886 -369.407)",
    fill: "#5796ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_99",
    "data-name": "Path 99",
    d: "M141.559,442.076c0,.1-11.85.186-26.545.186s-26.545-.085-26.545-.186,11.85-.186,26.545-.186S141.559,441.983,141.559,442.076Z",
    transform: "translate(-83.095 -369.711)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_100",
    "data-name": "Path 100",
    d: "M116.332,403.8c-.085.051-.449-.364-.8-.94s-.576-1.083-.491-1.134.449.364.8.94S116.416,403.744,116.332,403.8Z",
    transform: "translate(-87.172 -363.544)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_101",
    "data-name": "Path 101",
    d: "M116.589,412.557a2.946,2.946,0,0,1,.279-1.414c.245-.753.533-1.337.626-1.3a2.963,2.963,0,0,1-.279,1.422C116.936,412.007,116.691,412.591,116.589,412.557Z",
    transform: "translate(-87.412 -364.789)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102",
    "data-name": "Path 102",
    d: "M119.378,421.831c-.093.051-.482-.584-.846-1.405a3.851,3.851,0,0,1-.542-1.566c.093-.051.482.584.846,1.405A3.851,3.851,0,0,1,119.378,421.831Z",
    transform: "translate(-87.628 -366.174)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_103",
    "data-name": "Path 103",
    d: "M113.058,429.517c-.076-.068.237-.55.7-1.092s.9-.914.982-.846-.237.559-.7,1.092S113.134,429.627,113.058,429.517Z",
    transform: "translate(-86.869 -367.512)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_104",
    "data-name": "Path 104",
    d: "M111.281,416.179c0,.1-.525.093-1.134,0s-1.083-.271-1.067-.372.525-.093,1.126,0S111.3,416.078,111.281,416.179Z",
    transform: "translate(-86.26 -365.695)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-8",
    transform: "translate(145.575 117.946)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_372",
    "data-name": "Rectangle 372",
    width: 124.953,
    height: 99.644,
    transform: "translate(14.672 186.513)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_305",
    "data-name": "Group 305",
    transform: "translate(23.772 186.369)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_105",
    "data-name": "Path 105",
    d: "M191.38,355.417c14.711,5.248,30.938,6.374,46.724,6.67a43.11,43.11,0,0,1,9.751.846,12.367,12.367,0,0,1,7.847,5.434c1.769,3.09,1.583,6.958.576,10.369s-2.742,6.568-4,9.9a36.948,36.948,0,0,0-1.972,18.461,17.335,17.335,0,0,0,2.607,7.449,8.541,8.541,0,0,0,6.619,3.877c4.749.068,8-4.6,10.352-8.727,9.658-16.929,20.1-36.143,26.282-54.621Z",
    transform: "translate(-191.38 -355.07)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_106",
    "data-name": "Path 106",
    d: "M230.89,454.434c-.127,0-.22-22.084-.22-49.323s.093-49.331.22-49.331.22,22.084.22,49.331S231.009,454.434,230.89,454.434Z",
    transform: "translate(-173.641 -168.81)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_107",
    "data-name": "Path 107",
    d: "M274.124,255.9c-.372-2.489-7.8-10.7-7.8-10.7s-3.707-14.906-4.825-19.3a14.508,14.508,0,0,0-1.617-3.606,28.991,28.991,0,0,0-10.835-10.454l-10.284-5.781L236.3,200.6l-24.7-12.7-6.7,11.85s-16.26,5.163-18.41,8.828,1.067,53.157,1.067,53.157-6.772,28.542-8.236,34.451.457,12.951.457,12.951L191.9,293.943c3.767-4.723,12.028-6.9,17.962-6.814l50.711.229-2.04-14.2,41.027,7.94s7.051-13.763,7.618-14.034S274.124,255.9,274.124,255.9Z",
    transform: "translate(-165.674 -143.032)",
    fill: "#5796ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_108",
    "data-name": "Path 108",
    d: "M216.315,207.348c-.355-.364,2.861,10.513,6.907,21.593a54.435,54.435,0,0,1,3.276,18.681v40.122l24.31-1.651-3.631-26.426s-2.963-17.048-3.792-23.531c-.762-5.925-3.386-22.008-3.386-22.008S226.5,217.717,216.315,207.348Z",
    transform: "translate(-171.433 -146.017)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_109",
    "data-name": "Path 109",
    d: "M280.055,278.166a1.692,1.692,0,0,1,0-.618,8.88,8.88,0,0,1,.322-1.634,11,11,0,0,1,2.776-4.715,11.147,11.147,0,0,1,4.715-2.793,8.881,8.881,0,0,1,1.634-.322,1.626,1.626,0,0,1,.609,0c0,.076-.846.169-2.15.618a11.715,11.715,0,0,0-7.288,7.3C280.224,277.32,280.131,278.166,280.055,278.166Z",
    transform: "translate(-181.22 -155.34)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_110",
    "data-name": "Path 110",
    d: "M281.54,268.432a7.838,7.838,0,0,1,3.716-1.075,7.618,7.618,0,0,1,3.834.457c0,.135-1.693-.195-3.8,0S281.591,268.559,281.54,268.432Z",
    transform: "translate(-181.452 -155.222)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_306",
    "data-name": "Group 306",
    transform: "translate(17.33 135.108)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_111",
    "data-name": "Path 111",
    d: "M185.886,294.51,183.77,296.9a17.1,17.1,0,0,0,8.566,5.671,43.609,43.609,0,0,0,10.335.931,14.72,14.72,0,0,0,4.181-.4c1.38-.4,2.658-1.177,4.088-1.261a10.438,10.438,0,0,1,2.836.406,5.5,5.5,0,0,0,2.844.042,2.235,2.235,0,0,0,1.651-2.091A149.121,149.121,0,0,0,185.886,294.51Z",
    transform: "translate(-183.77 -294.51)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_112",
    "data-name": "Path 112",
    d: "M260.494,296.421l-5.925-6.331L242.253,287s-11.241,3.386-11.512,3.386-9.785-2.607-9.785-2.607l-3.327,12.206,17.141,1.177,19.57-.787s1.024-.948.415-1.6,3.276,1.1,3.733,1.117,1.337.372,1.947-.356C260.85,298.994,261.408,297.394,260.494,296.421Z",
    transform: "translate(-171.639 -158.249)",
    fill: "#ffbe9d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_113",
    "data-name": "Path 113",
    d: "M259.069,300.235a10.921,10.921,0,0,1-1.947-.559c-1.185-.372-2.836-.846-4.672-1.354s-3.53-.846-4.757-1.058a9.963,9.963,0,0,1-1.972-.466,8.558,8.558,0,0,1,2.023.152,43.8,43.8,0,0,1,4.808.948,40.781,40.781,0,0,1,4.672,1.49A7.983,7.983,0,0,1,259.069,300.235Z",
    transform: "translate(-175.952 -159.752)",
    fill: "#eb996e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_114",
    "data-name": "Path 114",
    d: "M264.858,297.262a26.7,26.7,0,0,1-2.726-.846c-1.693-.559-4-1.253-6.6-1.972a39.052,39.052,0,0,0-6.653-1.642,15.7,15.7,0,0,0-2.827.11,2.3,2.3,0,0,1,.736-.254,8,8,0,0,1,2.108-.169,27.451,27.451,0,0,1,6.772,1.532c2.539.762,4.926,1.464,6.585,2.108.846.313,1.481.6,1.938.8a2.539,2.539,0,0,1,.669.33Z",
    transform: "translate(-176.003 -159.09)",
    fill: "#eb996e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_115",
    "data-name": "Path 115",
    d: "M184.122,212.33s-8.845,6.154-11,15.008-11.478,45.04-9.565,50.448,39.106,10.725,39.106,10.725l4.41-18.622-18.893-5.172s.245-17.225.482-24.361S184.122,212.33,184.122,212.33Z",
    transform: "translate(-163.296 -146.784)",
    fill: "#5796ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_116",
    "data-name": "Path 116",
    d: "M214.085,283.64l6.086,1.5-3.665,14.034-5.976-.956Z",
    transform: "translate(-170.549 -157.733)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117",
    "data-name": "Path 117",
    d: "M163.434,285.4a5.471,5.471,0,0,0,.093.846,4.122,4.122,0,0,0,1.3,2.108c1.617,1.507,4.706,2.759,8.617,3.462h0c1.786.593,3.826,1.058,6,1.549s4.529.99,7,1.49c4.952,1.016,10.428,2.082,16.235,3.166l-.254.161c.415-1.693.846-3.547,1.312-5.4,1.041-4.232,2.057-8.4,3.013-12.316l.152.254-16.751-4.749h0a16.692,16.692,0,0,0-7.322-1.287,16.228,16.228,0,0,0-5.527,1.3,18.53,18.53,0,0,0-3.174,1.761l-.77.559a1.645,1.645,0,0,1-.271.178,2.621,2.621,0,0,1,.237-.22c.161-.135.406-.347.745-.6a17.118,17.118,0,0,1,3.157-1.854,16.032,16.032,0,0,1,5.587-1.4,16.76,16.76,0,0,1,7.466,1.236h0l16.8,4.706.2.051-.051.2c-.957,3.919-1.964,8.05-3,12.324-.457,1.845-.9,3.674-1.32,5.392l-.051.2h-.2c-5.807-1.092-11.275-2.175-16.226-3.208-2.472-.516-4.816-1.033-7-1.541s-4.232-.99-6.027-1.608h0c-3.961-.753-7.051-2.057-8.685-3.64a4.088,4.088,0,0,1-1.27-2.209A2.581,2.581,0,0,1,163.434,285.4Z",
    transform: "translate(-163.312 -156.311)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_118",
    "data-name": "Path 118",
    d: "M191.352,274.883c-.051.059-.686-.525-1.82-1.278a17.4,17.4,0,0,0-10.056-2.937c-1.371,0-2.209.186-2.226.11a6.984,6.984,0,0,1,2.209-.415,15.38,15.38,0,0,1,10.276,2.988A6.771,6.771,0,0,1,191.352,274.883Z",
    transform: "translate(-165.439 -155.688)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_119",
    "data-name": "Path 119",
    d: "M195.837,239.91a6.914,6.914,0,0,1,0,1.134c0,.736-.076,1.786-.178,3.09-.212,2.6-.592,6.179-1.278,10.107a68.992,68.992,0,0,1-2.345,9.92c-.2.618-.423,1.177-.6,1.693l-.542,1.219a5.29,5.29,0,0,1-.584.982,5.739,5.739,0,0,1,.423-1.05c.144-.364.3-.779.474-1.236s.347-1.05.533-1.693a88.54,88.54,0,0,0,2.209-9.9c.677-3.911,1.109-7.474,1.4-10.064.127-1.227.237-2.252.322-3.064A4.809,4.809,0,0,1,195.837,239.91Z",
    transform: "translate(-167.444 -151.019)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_120",
    "data-name": "Path 120",
    d: "M220.232,224.477a6.547,6.547,0,0,0-.288-.626,3.758,3.758,0,0,0-1.278-1.388,3.166,3.166,0,0,0-2.751-.406,3.538,3.538,0,0,0-2.319,2.632l-.118.6-.262-.559a58.792,58.792,0,0,1-2.582-6.535,34.357,34.357,0,0,1-1.913-11.546c0-.753.1-1.43.144-2.031a9.194,9.194,0,0,1,.271-1.507,7.9,7.9,0,0,1,.372-1.253,30.048,30.048,0,0,0-.482,4.791,36.931,36.931,0,0,0,2.023,11.41,65.384,65.384,0,0,0,2.539,6.5l-.381.051a3.885,3.885,0,0,1,2.616-2.869,3.386,3.386,0,0,1,2.988.516,3.674,3.674,0,0,1,1.253,1.532,2.2,2.2,0,0,1,.161.508C220.24,224.409,220.249,224.477,220.232,224.477Z",
    transform: "translate(-170.271 -145.176)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_121",
    "data-name": "Path 121",
    d: "M246.628,226.541a6.667,6.667,0,0,1-.195-1.007,10.69,10.69,0,0,1-.178-2.836,5.925,5.925,0,0,1,2.04-3.75,3.9,3.9,0,0,1,2.463-.889,3.386,3.386,0,0,1,2.59,1.16l-.372.22-.8-2.023c-1.583-3.987-2.988-7.618-3.987-10.234l-1.16-3.123a5.859,5.859,0,0,1-.364-1.16,6.636,6.636,0,0,1,.525,1.1c.339.846.77,1.837,1.3,3.073,1.075,2.6,2.539,6.2,4.105,10.157l.8,2.031.516,1.3-.846-1.092a2.929,2.929,0,0,0-2.26-1.016,3.513,3.513,0,0,0-2.218.77,5.764,5.764,0,0,0-1.989,3.479,12.013,12.013,0,0,0,.051,2.785,4.283,4.283,0,0,1-.008,1.05Z",
    transform: "translate(-176.03 -145.336)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_122",
    "data-name": "Path 122",
    d: "M265.249,233.31c.119,0,2.031,12.849,4.275,28.737s3.953,28.779,3.834,28.779-2.031-12.849-4.275-28.779S265.13,233.327,265.249,233.31Z",
    transform: "translate(-178.95 -150.005)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_307",
    "data-name": "Group 307",
    transform: "translate(40.616 73.156)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_123",
    "data-name": "Path 123",
    d: "M211.28,221.32a26.536,26.536,0,0,0,2.108,9.565,6.719,6.719,0,0,1,3.386-2.683c1.744-.415,3.513.66,4.774,1.981a8.659,8.659,0,0,0-1.524-3.657,4.292,4.292,0,0,0-3.386-1.752,2.963,2.963,0,0,0-2.819,2.3l-2.429-5.7",
    transform: "translate(-211.28 -221.32)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_124",
    "data-name": "Path 124",
    d: "M192.9,230.091c-.076,0-.051-.889-.3-2.268a13.924,13.924,0,0,0-2.057-5.036,15.186,15.186,0,0,0-1.938-2.294,13.02,13.02,0,0,0-1.938-1.515c-1.193-.753-2.031-1.041-2-1.117a1.769,1.769,0,0,1,.6.152,3.581,3.581,0,0,1,.686.262,6.483,6.483,0,0,1,.846.44,11.85,11.85,0,0,1,2.057,1.473,14.05,14.05,0,0,1,2.023,2.353,12.62,12.62,0,0,1,2,5.231,8.54,8.54,0,0,1,.085,1.693C192.955,229.871,192.93,230.091,192.9,230.091Z",
    transform: "translate(-166.576 -147.633)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_125",
    "data-name": "Path 125",
    d: "M246.361,158.058a18.139,18.139,0,0,0-18.5-16.21h-.94c-10.115.846-15.041,9.912-13.907,19.993l2.776,35.466,1.177,1.439a18.96,18.96,0,0,0,22.516,5.307h0l-.779-11.41s9.7-1.761,9.565-11.495C248.206,176.426,247.292,166.76,246.361,158.058Z",
    transform: "translate(-170.905 -135.96)",
    fill: "#ffbe9d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_126",
    "data-name": "Path 126",
    d: "M241.151,201.216a23.565,23.565,0,0,1-12.841-3.386s3.174,6.932,12.866,5.807Z",
    transform: "translate(-173.279 -144.557)",
    fill: "#eb996e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_127",
    "data-name": "Path 127",
    d: "M248.3,170.238a1.405,1.405,0,0,1-1.3,1.439,1.337,1.337,0,0,1-1.464-1.219,1.4,1.4,0,0,1,1.3-1.439,1.329,1.329,0,0,1,1.464,1.219Z",
    transform: "translate(-175.923 -140.132)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_128",
    "data-name": "Path 128",
    d: "M248.642,164.184c-.11.169-1.21.288-2.539,1s-2.108,1.6-2.285,1.583,0-.245.33-.643a6.391,6.391,0,0,1,1.778-1.38,5.789,5.789,0,0,1,2.065-.686C248.49,164.007,248.7,164.1,248.642,164.184Z",
    transform: "translate(-175.649 -139.369)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_129",
    "data-name": "Path 129",
    d: "M231.7,171.108a1.38,1.38,0,0,1-1.3,1.439,1.329,1.329,0,0,1-1.464-1.219,1.4,1.4,0,0,1,1.3-1.439,1.329,1.329,0,0,1,1.464,1.219Z",
    transform: "translate(-173.374 -140.266)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_130",
    "data-name": "Path 130",
    d: "M231.033,166.339a23.386,23.386,0,0,0-2.539-.923c-1.439-.355-2.632-.279-2.759-.4s.152-.169.669-.212a7.186,7.186,0,0,1,2.243.212,6.5,6.5,0,0,1,2,.846C230.982,166.136,231.084,166.323,231.033,166.339Z",
    transform: "translate(-172.879 -139.484)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_131",
    "data-name": "Path 131",
    d: "M238.7,178.094a10.428,10.428,0,0,1,2.421-.5c.381,0,.736-.135.8-.4a1.913,1.913,0,0,0-.279-1.117l-1.21-2.886c-1.693-4.1-2.895-7.474-2.726-7.533s1.693,3.2,3.327,7.3c.406,1.016.8,1.981,1.16,2.9a2.226,2.226,0,0,1,.237,1.49.965.965,0,0,1-.618.576,2.436,2.436,0,0,1-.643.11A9.605,9.605,0,0,1,238.7,178.094Z",
    transform: "translate(-174.718 -139.617)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_132",
    "data-name": "Path 132",
    d: "M230.768,159.569c-.169.4-1.651.135-3.386.254s-3.208.542-3.386.161c-.1-.178.169-.55.753-.914a5.925,5.925,0,0,1,5.206-.322C230.514,159.044,230.819,159.374,230.768,159.569Z",
    transform: "translate(-172.613 -138.486)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_133",
    "data-name": "Path 133",
    d: "M248.337,159.913c-.33.347-1.617,0-3.157,0s-2.853.262-3.157-.093c-.135-.169.068-.516.635-.846a5.495,5.495,0,0,1,5.079.076C248.295,159.4,248.481,159.752,248.337,159.913Z",
    transform: "translate(-175.378 -138.501)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134",
    "data-name": "Path 134",
    d: "M248.816,148.341a1.854,1.854,0,0,0-1.947-1.5,3.86,3.86,0,0,0,1.337-.686,1.346,1.346,0,0,0,.466-1.354c-.254-.753-1.219-.914-1.981-1.126a5.079,5.079,0,0,1-2.539-1.693c-.923-1.168-1.278-2.692-2.082-3.953a6.458,6.458,0,0,0-10.005-1.1,6.729,6.729,0,0,0-10.826,1.651,7.847,7.847,0,0,0-10.75,8.591l6.061,3.716a3.276,3.276,0,0,1,4-2.844c1.828.533,3,2.649,4.892,2.793,1.481.11,2.743-1.033,4.173-1.414a7.067,7.067,0,0,1,5.138,1.109,20.5,20.5,0,0,0,4.808,2.421,9.98,9.98,0,0,0,6.171-.736,6.255,6.255,0,0,0,2.285-1.414A2.827,2.827,0,0,0,248.816,148.341Z",
    transform: "translate(-170.525 -134.893)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_135",
    "data-name": "Path 135",
    d: "M217.348,148.79l27.764-.152a12.612,12.612,0,0,0-4.232-4.6,21.669,21.669,0,0,0-12.7-4.173c-4.529,0-13.586,5.815-16.777,9.023-2.539,2.539-2.472,4.732-2.472,4.732-.322,3.606,1.8,7.618,2.709,11.148.457,1.811,1.414,7.3,1.414,7.3h0c1.524-.042,2.057-1.278,1.786-2.785l-.449-5.925a8.964,8.964,0,0,0,2.446-10.53C216.459,152.294,215.545,149.848,217.348,148.79Z",
    transform: "translate(-170.299 -135.656)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_136",
    "data-name": "Path 136",
    d: "M213.079,164.417c-1.414-4.909-2.717-10.157-1.21-15.067h-.846l-.339.245a3.885,3.885,0,0,0-4.368,5.984,3.386,3.386,0,0,0-3.386,2.937,6.281,6.281,0,0,0,.906,3.233,7.567,7.567,0,0,1,1.058,3.217,2.412,2.412,0,0,1-1.845,2.5,2.768,2.768,0,0,0,3.14,1.532,5.527,5.527,0,0,1-1.9,2.4c1.811,1.236,4.291.846,6.255-.144a5.333,5.333,0,0,0,2.793-2.59A6.682,6.682,0,0,0,213.079,164.417Z",
    transform: "translate(-169.382 -137.113)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137",
    "data-name": "Path 137",
    d: "M213.223,173.874c-.169-.068-6.772-1.8-6.357,4.842s6.983,4.892,6.983,4.7S213.223,173.874,213.223,173.874Z",
    transform: "translate(-169.984 -140.84)",
    fill: "#ffbe9d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138",
    "data-name": "Path 138",
    d: "M212.682,181.394a2.262,2.262,0,0,1-.3.186,1.143,1.143,0,0,1-.846.068,2.866,2.866,0,0,1-1.473-2.5,3.86,3.86,0,0,1,.229-1.693,1.354,1.354,0,0,1,.846-.94.6.6,0,0,1,.7.279c.1.178.059.313.1.33s.135-.127.068-.4a.8.8,0,0,0-.94-.533,1.642,1.642,0,0,0-1.151,1.1,4.114,4.114,0,0,0-.3,1.879,2.99,2.99,0,0,0,1.862,2.776,1.253,1.253,0,0,0,1.041-.237C212.682,181.555,212.707,181.4,212.682,181.394Z",
    transform: "translate(-170.407 -141.233)",
    fill: "#eb996e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_139",
    "data-name": "Path 139",
    d: "M206.2,164.853a1.155,1.155,0,0,1-.127-.779,2.48,2.48,0,0,1,1.244-1.693,7.618,7.618,0,0,1,3.047-.736A3.75,3.75,0,0,0,213.4,160.1a5.527,5.527,0,0,0,.525-3.5c-.161-1.117-.457-2.125-.6-3a4.918,4.918,0,0,1,.042-2.853,13.194,13.194,0,0,0,.313,2.776c.186.846.516,1.837.719,3.013a5.815,5.815,0,0,1-.559,3.826,3.242,3.242,0,0,1-1.583,1.337,6.856,6.856,0,0,1-1.837.406,7.932,7.932,0,0,0-2.92.576,2.472,2.472,0,0,0-1.227,1.456,5.355,5.355,0,0,0-.068.7Z",
    transform: "translate(-169.864 -137.33)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_140",
    "data-name": "Path 140",
    d: "M204.29,161.829a1.358,1.358,0,0,1-.2-.6,2.836,2.836,0,0,1,.33-1.693,3.013,3.013,0,0,1,.787-.948,3.386,3.386,0,0,1,1.278-.592,3.75,3.75,0,0,0,1.261-.525,1.507,1.507,0,0,0,.5-1.219c0-.5-.059-1.033-.042-1.566a7.828,7.828,0,0,1,.169-1.515,7.009,7.009,0,0,1,.956-2.37,1.828,1.828,0,0,1,1.464-.94c.44,0,.626.2.609.22a1.591,1.591,0,0,0-.593,0,1.693,1.693,0,0,0-1.177.931,7.72,7.72,0,0,0-.8,2.268,8.542,8.542,0,0,0-.127,1.422c0,.491.076,1.016.051,1.591a1.972,1.972,0,0,1-.7,1.591,3.809,3.809,0,0,1-1.447.584,2.751,2.751,0,0,0-1.879,1.27,3.724,3.724,0,0,0-.44,2.091Z",
    transform: "translate(-169.557 -137.191)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_141",
    "data-name": "Path 141",
    d: "M244.905,142.636a1.351,1.351,0,0,1-1.371-.042,4,4,0,0,1-1.261-1.075,5.3,5.3,0,0,0-1.541-1.363,4.6,4.6,0,0,0-5.011.33c-.846.592-1.549,1.43-2.539,2.125a4.435,4.435,0,0,1-1.693.77,3.589,3.589,0,0,1-1.888-.178c-1.2-.432-2.15-1.168-3.183-1.541a8.541,8.541,0,0,0-3.123-.567,8.27,8.27,0,0,0-5.079,1.735,9.091,9.091,0,0,0-2.37,2.785c-.415.77-.567,1.244-.609,1.227s0-.127.068-.355a7.357,7.357,0,0,1,.356-.965,8.651,8.651,0,0,1,2.328-2.979,8.515,8.515,0,0,1,5.256-1.921,8.634,8.634,0,0,1,3.31.567c1.117.406,2.082,1.143,3.174,1.524a3.073,3.073,0,0,0,1.625.161,3.91,3.91,0,0,0,1.464-.677c.889-.635,1.634-1.473,2.539-2.1a4.791,4.791,0,0,1,2.9-.956,5.129,5.129,0,0,1,2.539.694,5.765,5.765,0,0,1,1.583,1.5,3.817,3.817,0,0,0,1.126,1.083A1.9,1.9,0,0,0,244.905,142.636Z",
    transform: "translate(-171.269 -135.545)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_142",
    "data-name": "Path 142",
    d: "M234.5,182.41c.212,0,.449,1.371,1.837,2.175s2.869.4,2.92.593-.3.339-.931.457a3.58,3.58,0,0,1-2.421-.406,3.183,3.183,0,0,1-1.456-1.845C234.294,182.8,234.4,182.418,234.5,182.41Z",
    transform: "translate(-174.209 -142.189)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_143",
    "data-name": "Path 143",
    d: "M335.273,338.093a12.951,12.951,0,0,0-9.311-3.1l-5.722,18.173c4.19.186,8.371,2.345,12.417,1.236a8.862,8.862,0,0,0,6.171-7.279A10.521,10.521,0,0,0,335.273,338.093Z",
    transform: "translate(-187.395 -165.614)",
    fill: "#5796ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_144",
    "data-name": "Path 144",
    d: "M326.206,334.464c0-.144.618-.262,1.693-.254a14.135,14.135,0,0,1,4.681.889,12.7,12.7,0,0,1,5.705,4.427,11.791,11.791,0,0,1,1.9,3.944,10.378,10.378,0,0,1,.135,4.766,9.692,9.692,0,0,1-2.074,4.342,9.166,9.166,0,0,1-3.69,2.539,13.264,13.264,0,0,1-7.195.466,21.728,21.728,0,0,1-4.486-1.4c-1.007-.432-1.54-.753-1.49-.9s.66-.1,1.693.076,2.6.508,4.461.677a12.908,12.908,0,0,0,6.221-.846,7.406,7.406,0,0,0,2.793-2.065,7.8,7.8,0,0,0,1.574-3.386,9.311,9.311,0,0,0-1.549-7.11,12.265,12.265,0,0,0-4.655-4.165,21.034,21.034,0,0,0-4.173-1.456C326.781,334.794,326.189,334.616,326.206,334.464Z",
    transform: "translate(-187.571 -165.498)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_145",
    "data-name": "Path 145",
    d: "M262.193,415.06,249.75,449.925l43.3,15.7c1.253-4.232-18.139-20.653-18.139-20.653l8.888-22.008Z",
    transform: "translate(-176.571 -177.913)",
    fill: "#5796ff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_308",
    "data-name": "Group 308",
    transform: "translate(83.667 260.296)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_146",
    "data-name": "Path 146",
    d: "M264.1,442.444a1.879,1.879,0,0,0-1.955,1.574,1.8,1.8,0,0,0,1.541,1.947,1.981,1.981,0,0,0,2.065-1.693c0-.923-.914-1.981-1.828-1.854",
    transform: "translate(-262.141 -442.408)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_147",
    "data-name": "Path 147",
    d: "M249.75,455.613l1.261-3.513,41.121,16.4s1.625,1.532.914,2.81Z",
    transform: "translate(-176.571 -183.6)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_148",
    "data-name": "Path 148",
    d: "M279.527,450.328c-.085.212-1.177-.076-2.463.229s-2.167.99-2.328.846.593-1.261,2.158-1.6S279.637,450.15,279.527,450.328Z",
    transform: "translate(-180.404 -183.233)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_149",
    "data-name": "Path 149",
    d: "M284.278,454.558c0,.22-1.075.245-2.116.846s-1.591,1.507-1.8,1.422.093-1.329,1.405-2.1S284.278,454.355,284.278,454.558Z",
    transform: "translate(-181.262 -183.934)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_150",
    "data-name": "Path 150",
    d: "M285.654,461.569c-.2,0-.118-1.185.846-2.15s2.116-1.058,2.142-.846-.8.6-1.583,1.405S285.874,461.629,285.654,461.569Z",
    transform: "translate(-182.07 -184.58)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_151",
    "data-name": "Path 151",
    d: "M281.3,443.927c-.161.161-1.024-.482-2.243-.846s-2.294-.313-2.336-.533,1.117-.652,2.539-.212S281.468,443.8,281.3,443.927Z",
    transform: "translate(-180.712 -182.072)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_152",
    "data-name": "Path 152",
    d: "M282.07,436.733a4.385,4.385,0,0,1-2.158-.8,9.93,9.93,0,0,1-2.015-1.524,10.694,10.694,0,0,1-1.007-1.109,2.9,2.9,0,0,1-.474-.745.973.973,0,0,1,.313-1.16,1.244,1.244,0,0,1,1.1-.152,3.106,3.106,0,0,1,.77.406,8.467,8.467,0,0,1,1.185.957,8.091,8.091,0,0,1,1.524,2.031,3.851,3.851,0,0,1,.635,2.226c-.119,0-.372-.8-1.109-1.947a9.465,9.465,0,0,0-1.541-1.786,8.838,8.838,0,0,0-1.109-.846c-.415-.288-.8-.432-.99-.271s-.093.093-.042.262a2.218,2.218,0,0,0,.347.55,10.328,10.328,0,0,0,.906,1.067,12.411,12.411,0,0,0,1.8,1.566C281.325,436.268,282.121,436.623,282.07,436.733Z",
    transform: "translate(-180.654 -180.388)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_153",
    "data-name": "Path 153",
    d: "M282.642,436.855a3.724,3.724,0,0,1,.186-2.3,7.618,7.618,0,0,1,1.16-2.268,8.332,8.332,0,0,1,1.024-1.117,1.938,1.938,0,0,1,1.786-.593,1.092,1.092,0,0,1,.686.94,3.15,3.15,0,0,1-.068.846,5.248,5.248,0,0,1-2.268,3.386c-1.253.846-2.226.745-2.218.669a9.689,9.689,0,0,0,1.9-1.117,5.35,5.35,0,0,0,1.422-1.786,4.758,4.758,0,0,0,.415-1.27c.1-.482.059-.923-.127-.931a1.3,1.3,0,0,0-1.016.432,7.524,7.524,0,0,0-.965.982,8.048,8.048,0,0,0-1.2,2.006C282.828,436.008,282.768,436.855,282.642,436.855Z",
    transform: "translate(-181.606 -180.29)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_154",
    "data-name": "Path 154",
    d: "M209.238,304.906c-6.568.152-12.8,1.075-17.327,5.841-6,6.323-13.416,15.321-13.839,21.559-.626,9.311,5,12.1,9.108,14.39a11.529,11.529,0,0,0,5.925,1.38l75.91-.576,2.379-12.858-49.094-12.1,2.04-18.478Z",
    transform: "translate(-165.558 -160.869)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_155",
    "data-name": "Path 155",
    d: "M232.415,303.85l23.878-1.1s41.256,2.294,50.051,10.361,7.7,17.234,4.766,26.028-28.779,65.075-28.779,65.075,2.1,3.581.923,7.153a9.438,9.438,0,0,1-6.772,6.416l-22.956-8.465s-3.115-1.1-.914-4.038,3.665-3.479,3.665-3.479v-5.866s8.067-14.669,8.795-16.684,8.464-31.86,8.464-31.86l5.138-8.828s-12.417-5.841-23.184-10.073l-25.14-6.2Z",
    transform: "translate(-173.592 -160.668)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_156",
    "data-name": "Path 156",
    d: "M275.808,426.376a22.532,22.532,0,0,1-2.015-1.32,27.265,27.265,0,0,0-10.716-4.071,23.635,23.635,0,0,1-2.387-.356,9.157,9.157,0,0,1,2.421.042,22.854,22.854,0,0,1,10.86,4.131,9.211,9.211,0,0,1,1.837,1.574Z",
    transform: "translate(-178.251 -178.758)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_157",
    "data-name": "Path 157",
    d: "M290.684,420.746a7.661,7.661,0,0,1-1.329-1.405c-.779-.906-1.811-2.192-2.886-3.665s-2.006-2.836-2.641-3.843a8.66,8.66,0,0,1-.948-1.693,8.887,8.887,0,0,1,1.2,1.515l2.742,3.758c1.024,1.388,1.964,2.641,2.776,3.733a8.88,8.88,0,0,1,1.083,1.6Z",
    transform: "translate(-181.658 -177.157)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_158",
    "data-name": "Path 158",
    d: "M299.651,335.58c0,.068-.846.254-2.175.694a22.854,22.854,0,0,0-9.192,5.739,22.772,22.772,0,0,1-1.583,1.651,7.887,7.887,0,0,1,1.354-1.862,19.324,19.324,0,0,1,4.232-3.58,19.1,19.1,0,0,1,5.079-2.243,7.692,7.692,0,0,1,2.285-.4Z",
    transform: "translate(-182.245 -165.709)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_159",
    "data-name": "Path 159",
    d: "M274.3,374.662a2.013,2.013,0,0,1,.093-.5l.355-1.4,1.371-5.121,4.7-16.853c.957-3.293,1.769-6.425,2.692-9.269a19.357,19.357,0,0,1,4.325-6.594,24.78,24.78,0,0,1,4.1-3.386c.533-.339.948-.592,1.244-.745a2.69,2.69,0,0,1,.449-.229s-.576.389-1.591,1.109a27.489,27.489,0,0,0-3.978,3.462,19.357,19.357,0,0,0-4.165,6.518c-.846,2.8-1.693,5.976-2.649,9.252l-4.816,16.811c-.626,2.108-1.143,3.826-1.515,5.079-.178.559-.313,1.016-.432,1.371a1.938,1.938,0,0,1-.178.491Z",
    transform: "translate(-180.341 -164.939)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_160",
    "data-name": "Path 160",
    d: "M249.015,328.245c-.127,0-.626-4.452-1.126-9.971s-.846-10.005-.677-10.014.618,4.452,1.117,9.971S249.134,328.236,249.015,328.245Z",
    transform: "translate(-176.175 -161.514)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161",
    "data-name": "Path 161",
    d: "M200.394,344.44c-.068,0-.432-.686-1.185-1.744a17.523,17.523,0,0,0-3.462-3.648,17.776,17.776,0,0,0-4.376-2.48c-1.21-.474-2-.652-1.981-.728a6.771,6.771,0,0,1,2.082.432,15.024,15.024,0,0,1,8,6.247A6.518,6.518,0,0,1,200.394,344.44Z",
    transform: "translate(-167.303 -165.749)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_162",
    "data-name": "Path 162",
    d: "M215.937,326.046c0,.068-1.05-.576-2.8-1.38a26.443,26.443,0,0,0-14.694-2.1c-1.9.271-3.064.609-3.081.533a2.921,2.921,0,0,1,.787-.3,18.309,18.309,0,0,1,2.243-.542,24.141,24.141,0,0,1,14.864,2.133,17.928,17.928,0,0,1,2,1.151,3.074,3.074,0,0,1,.686.508Z",
    transform: "translate(-168.22 -163.607)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_163",
    "data-name": "Path 163",
    d: "M276.7,338.079a2.6,2.6,0,0,1-.6-.1l-1.693-.364-6.179-1.363c-5.223-1.168-12.451-2.742-20.467-4.325s-15.3-2.895-20.569-3.8l-6.255-1.075-1.693-.3a2.42,2.42,0,0,1-.584-.144,5.333,5.333,0,0,1,.6.051l1.693.22c1.481.2,3.623.525,6.272.94,5.29.846,12.587,2.082,20.611,3.674s15.236,3.208,20.45,4.452c2.6.626,4.706,1.151,6.154,1.532l1.693.44a3.263,3.263,0,0,1,.567.161Z",
    transform: "translate(-171.797 -164.331)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_164",
    "data-name": "Path 164",
    d: "M227.992,326.333a23.469,23.469,0,0,0-1.05-2.421,10.438,10.438,0,0,0-1.693-2.243,27.541,27.541,0,0,0-2.658-2.3,40.217,40.217,0,0,0-5.443-3.386,18.131,18.131,0,0,1-2.319-1.32,14.3,14.3,0,0,1,2.463,1.041,31.815,31.815,0,0,1,5.57,3.31,24.933,24.933,0,0,1,2.675,2.362,9.81,9.81,0,0,1,1.693,2.378,8.085,8.085,0,0,1,.686,1.862A1.964,1.964,0,0,1,227.992,326.333Z",
    transform: "translate(-171.209 -162.496)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_165",
    "data-name": "Path 165",
    d: "M329.616,342c.093.1-1.177,1.38-2.167,3.335s-1.312,3.716-1.439,3.69a7.687,7.687,0,0,1,1.05-3.894A7.778,7.778,0,0,1,329.616,342Z",
    transform: "translate(-188.281 -166.694)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_309",
    "data-name": "Group 309",
    transform: "translate(87.001 88.578)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_166",
    "data-name": "Path 166",
    d: "M266.08,239.54l5.434,38.277.271.609a82.106,82.106,0,0,0-5.705-38.886Z",
    transform: "translate(-266.08 -239.54)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_167",
    "data-name": "Path 167",
    d: "M289.528,265.339l-17.665,30.879-43.533.948-.11,1.972,42.153-.313,1.337-.051,44.506.093,9-15.515,11.495-16.472a1.625,1.625,0,0,0-1.346-2.539l-44.43.169A1.625,1.625,0,0,0,289.528,265.339Z",
    transform: "translate(-173.265 -154.77)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_168",
    "data-name": "Path 168",
    d: "M340.189,286.83s2.285,2.1,1.93,3.877-.245,3.106-1.93,3.225a2.539,2.539,0,0,1-2.285,2.649s.516,2.793-2.734,3.276c0,0-1,2.988-3.047,2.26a17.72,17.72,0,0,1-3.386-1.566l-.6-1.083s-3.022-1.134-2.277-2.836c.457-1.033,2.015-1.3,2.015-1.3a2.9,2.9,0,0,1,.195-2.641c.719-.973,3.073-.169,3.073-.169a3.335,3.335,0,0,1,.745-2.3c.846-.956,4.554,1.625,4.554,1.625l2.04-2.438Z",
    transform: "translate(-188.239 -158.223)",
    fill: "#ffbe9d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_169",
    "data-name": "Path 169",
    d: "M335.559,301.4a21.164,21.164,0,0,1-3.758-2.074,20.593,20.593,0,0,1-3.521-2.455,21.592,21.592,0,0,1,3.758,2.082,21.3,21.3,0,0,1,3.521,2.446Z",
    transform: "translate(-188.629 -159.765)",
    fill: "#eb996e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_170",
    "data-name": "Path 170",
    d: "M338.886,297.613a17.633,17.633,0,0,1-3.487-1.845,17.9,17.9,0,0,1-3.259-2.218,17.1,17.1,0,0,1,3.487,1.845A17.9,17.9,0,0,1,338.886,297.613Z",
    transform: "translate(-189.222 -159.255)",
    fill: "#eb996e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_171",
    "data-name": "Path 171",
    d: "M335.71,291.107a11.646,11.646,0,0,1,3.09,1.642,27.661,27.661,0,0,1,2.9,1.93,9.384,9.384,0,0,1-3.14-1.557A16.58,16.58,0,0,1,335.71,291.107Z",
    transform: "translate(-189.77 -158.878)",
    fill: "#eb996e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_172",
    "data-name": "Path 172",
    d: "M344.951,265.685a.669.669,0,0,1-.212,0h-3.03l-8.837.068-29.16.068h-2.125a1.752,1.752,0,0,0-1.617.762q-1.016,1.811-1.981,3.572l-3.758,6.772-6.374,11.452c-1.811,3.233-3.293,5.857-4.334,7.711-.5.846-.906,1.574-1.193,2.082l-.322.533-.119.178a.446.446,0,0,1,.076-.2l.288-.559L283.38,296l4.232-7.779,6.3-11.5c1.185-2.158,2.438-4.427,3.724-6.772l1.989-3.6a2.2,2.2,0,0,1,1.989-.965h2.125l29.16.059,8.837.076,2.4.042h.626A.668.668,0,0,1,344.951,265.685Z",
    transform: "translate(-181.506 -154.93)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_173",
    "data-name": "Path 173",
    d: "M319.33,283.953a1.879,1.879,0,1,0,2.8-.33A2.006,2.006,0,0,0,319.33,283.953Z",
    transform: "translate(-187.204 -157.665)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_310",
    "data-name": "Group 310",
    transform: "translate(7.74 113.3)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_174",
    "data-name": "Path 174",
    d: "M173.244,269.808c-.372.152-.8.406-.8.846a.728.728,0,0,0,.618.66,7.864,7.864,0,0,0,1.811-.483c4.579-1.007,8.346-.042,12.7,1.693l.144-.144C185.983,268.631,178.17,267.8,173.244,269.808Z",
    transform: "translate(-172.44 -268.747)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-8",
    transform: "translate(47.982 403.916)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_175",
    "data-name": "Path 175",
    d: "M389.966,472.96c0,.119-76.562.22-170.983.22S48,473.045,48,472.96s76.545-.22,170.983-.22S389.966,472.8,389.966,472.96Z",
    transform: "translate(-48 -472.74)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Ribbon--inject-8",
    transform: "translate(122.867 66.994)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_176",
    "data-name": "Path 176",
    d: "M144.046,147.985c.144.144,28.255-9.514,28.255-9.514l-10.835-24.8-25,9.59,13.763,7.906Z",
    transform: "translate(-136.47 -80.683)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_177",
    "data-name": "Path 177",
    d: "M161,115.152V81.387s38.776-7.093,66.717-6.67,56.712,5,56.712,5v32.419S196.856,104.317,161,115.152Z",
    transform: "translate(-140.237 -74.698)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_178",
    "data-name": "Path 178",
    d: "M160.76,121.977,176,139.423V118.93S163.257,120.454,160.76,121.977Z",
    transform: "translate(-140.2 -81.49)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_179",
    "data-name": "Path 179",
    d: "M160.938,82.59c.127,0,.178,7.618.127,16.929s-.2,16.929-.322,16.929-.178-7.567-.127-16.929S160.811,82.59,160.938,82.59Z",
    transform: "translate(-140.175 -75.91)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_180",
    "data-name": "Path 180",
    d: "M317.195,144.924c-.144.144-28.255-9.514-28.255-9.514L299.749,110.6l25.021,9.573L311,128.079Z",
    transform: "translate(-159.882 -80.211)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_181",
    "data-name": "Path 181",
    d: "M304.236,119.186,289,136.631V117.62A112.369,112.369,0,0,1,304.236,119.186Z",
    transform: "translate(-159.891 -81.289)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_182",
    "data-name": "Path 182",
    d: "M306.771,80.63c.119,0,.254,7.356.3,16.438s0,16.438-.144,16.438-.254-7.356-.3-16.438S306.644,80.63,306.771,80.63Z",
    transform: "translate(-162.595 -75.609)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_183",
    "data-name": "Path 183",
    d: "M186.825,99.116a4.96,4.96,0,0,1,8.1-4.232l-1.185,1.422a2.929,2.929,0,0,0-2.387-.736,2.889,2.889,0,1,0,2.895,4.351l1.49,1.041a4.952,4.952,0,0,1-8.939-1.845Z",
    transform: "translate(-144.198 -77.624)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_184",
    "data-name": "Path 184",
    d: "M197.729,97.551a4.943,4.943,0,1,1,5.383,4.131,4.672,4.672,0,0,1-5.383-4.131Zm7.711-.8a2.819,2.819,0,1,0-2.539,3.157,2.751,2.751,0,0,0,2.539-3.157Z",
    transform: "translate(-145.866 -77.328)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_185",
    "data-name": "Path 185",
    d: "M219.727,100.266l-.364-5.4L217,99.488l-.931.059-2.92-4.165.347,5.282-1.955.127-.542-9,1.693-.11,3.724,5.375,2.954-5.8,1.693-.11.609,8.989Z",
    transform: "translate(-147.914 -77.225)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_186",
    "data-name": "Path 186",
    d: "M233.644,94.061c.051,2.015-1.422,3.3-3.826,3.386L228,97.5l.076,2.489-2.091.059-.254-9.065,3.9-.11C232.045,90.836,233.577,92.046,233.644,94.061Zm-2.116.059c0-.99-.686-1.549-1.964-1.515l-1.693.051.093,3.132,1.693-.051C230.927,95.7,231.554,95.1,231.528,94.12Z",
    transform: "translate(-150.176 -77.181)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_187",
    "data-name": "Path 187",
    d: "M237,90.77h2.082v7.313h4.52v1.693H237Z",
    transform: "translate(-151.906 -77.166)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_188",
    "data-name": "Path 188",
    d: "M253.083,98.355v1.693l-6.983-.2.262-9.015,6.772.2-.051,1.693-4.74-.144-.051,1.964,4.181.119-.051,1.625-4.181-.127-.059,2.091Z",
    transform: "translate(-153.304 -77.175)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_189",
    "data-name": "Path 189",
    d: "M258.388,92.962l-2.878-.169.1-1.693,7.838.474-.1,1.693-2.878-.178-.44,7.3-2.082-.127Z",
    transform: "translate(-154.748 -77.217)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_190",
    "data-name": "Path 190",
    d: "M272.57,99.743l-.152,1.693-6.958-.643.846-8.972,6.772.626-.152,1.693-4.723-.474-.178,1.955,4.165.381-.144,1.617-4.173-.381-.186,2.074Z",
    transform: "translate(-156.276 -77.327)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_191",
    "data-name": "Path 191",
    d: "M276.724,92.79l4.055.542c2.92.389,4.689,2.412,4.334,5.079s-2.607,4.232-5.527,3.809l-4.055-.542Zm2.988,7.762a2.793,2.793,0,1,0,.736-5.536l-1.888-.254-.736,5.536Z",
    transform: "translate(-157.823 -77.476)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Confetti--inject-8",
    transform: "translate(128.412 59.47)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_192",
    "data-name": "Path 192",
    d: "M327.29,83.764l2.218,2.6,6.247-2.6-1.828-2.734Z",
    transform: "translate(-171.314 -68.147)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_193",
    "data-name": "Path 193",
    d: "M322.731,69.06a3.25,3.25,0,1,1-3.25-3.25A3.25,3.25,0,0,1,322.731,69.06Z",
    transform: "translate(-169.616 -65.81)",
    fill: "#5796ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_194",
    "data-name": "Path 194",
    d: "M237.3,126.634A1.625,1.625,0,1,1,235.7,125,1.625,1.625,0,0,1,237.3,126.634Z",
    transform: "translate(-156.998 -74.899)",
    fill: "#5796ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_195",
    "data-name": "Path 195",
    d: "M147.992,97.846a1.236,1.236,0,1,1-1.219-1.236,1.236,1.236,0,0,1,1.219,1.236Z",
    transform: "translate(-143.404 -70.539)",
    fill: "#5796ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_196",
    "data-name": "Path 196",
    d: "M143.02,80.741l3.64.22,1.727-7.161-3.4.144Z",
    transform: "translate(-143.02 -67.037)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_197",
    "data-name": "Path 197",
    d: "M277.42,149.375l1.227,3.437,7.263-1.219-1.464-3.073Z",
    transform: "translate(-163.657 -78.51)",
    fill: "#5796ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_198",
    "data-name": "Path 198",
    d: "M190.233,126.1l-2.243,2.878,4.918,5.477,1.811-2.886Z",
    transform: "translate(-149.925 -75.067)",
    fill: "#455a64"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Stars--inject-8",
    transform: "translate(147.296 24.52)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_199",
    "data-name": "Path 199",
    d: "M178.061,46.23l8.591,8.761,12.1-4.571.482,3-5.24,10.725,4.833,8.007-.406,2.4L186.711,72.58l-6.924,7.593-1.625-1.227-1.431-9.658L165.812,63.6l-.482-2.209,11-3Z",
    transform: "translate(-165.33 -27.854)",
    fill: "#5796ff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_311",
    "data-name": "Group 311",
    transform: "translate(0 18.376)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_200",
    "data-name": "Path 200",
    d: "M178.061,46.23l8.591,8.761,12.1-4.571.482,3-5.24,10.725,4.833,8.007-.406,2.4L186.711,72.58l-6.924,7.593-1.625-1.227-1.431-9.658L165.812,63.6l-.482-2.209,11-3Z",
    transform: "translate(-165.33 -46.23)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_201",
    "data-name": "Path 201",
    d: "M178.061,43.32l8.591,8.769,12.1-2.116-5.68,10.885,5.756,10.852-12.113-2.031-8.549,8.82-1.8-12.147L165.33,60.943l11-5.468Z",
    transform: "translate(-165.33 -27.407)",
    fill: "#5796ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_202",
    "data-name": "Path 202",
    d: "M281.778,46.23l-8.6,8.761-12.1-4.571-.482,3,5.24,10.725-4.833,8.007.406,2.4,11.706-1.972,6.924,7.593,1.625-1.227,1.431-9.658L294.018,63.6l.482-2.209-11-3Z",
    transform: "translate(-179.959 -27.854)",
    fill: "#5796ff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_312",
    "data-name": "Group 312",
    transform: "translate(80.641 18.376)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_203",
    "data-name": "Path 203",
    d: "M281.778,46.23l-8.6,8.761-12.1-4.571-.482,3,5.24,10.725-4.833,8.007.406,2.4,11.706-1.972,6.924,7.593,1.625-1.227,1.431-9.658L294.018,63.6l.482-2.209-11-3Z",
    transform: "translate(-260.6 -46.23)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_204",
    "data-name": "Path 204",
    d: "M281.852,43.32l-8.6,8.769-12.1-2.116,5.68,10.885L261.08,71.71l12.113-2.031,8.549,8.82,1.8-12.147,11.029-5.409-11-5.468Z",
    transform: "translate(-180.032 -27.407)",
    fill: "#5796ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_205",
    "data-name": "Path 205",
    d: "M228.749,28.06,235.9,42.035l16.5-.973L251.84,44.9,241.361,56l2.836,11.6-1.4,2.768-13.535-6.865-11.334,6.636-1.515-2.125,1.93-12.333-11.156-11.1.254-2.869L222,42.238Z",
    transform: "translate(-171.758 -25.064)",
    fill: "#5796ff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_313",
    "data-name": "Group 313",
    transform: "translate(35.432 2.996)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_206",
    "data-name": "Path 206",
    d: "M228.749,28.06,235.9,42.035l16.5-.973L251.84,44.9,241.361,56l2.836,11.6-1.4,2.768-13.535-6.865-11.334,6.636-1.515-2.125,1.93-12.333-11.156-11.1.254-2.869L222,42.238Z",
    transform: "translate(-207.19 -28.06)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_207",
    "data-name": "Path 207",
    d: "M229.726,24.52l7.153,13.966,15.566,2.031L241.365,51.64l2.878,15.422-13.992-7.093-13.789,7.508,2.429-15.507-11.4-10.792,15.5-2.489Z",
    transform: "translate(-171.804 -24.52)",
    fill: "#5796ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-8",
    transform: "translate(233.719 139.158)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_208",
    "data-name": "Path 208",
    d: "M267.43,170.719l11.952,1.32a28.018,28.018,0,1,1-4.232,9.116h0Z",
    transform: "translate(-267.43 -159.989)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_209",
    "data-name": "Path 209",
    d: "M267.43,170.684c.466.626,2.886,3.826,7.83,10.386h-.178a.1.1,0,0,1,.152-.042.11.11,0,0,1,.051.118,27.823,27.823,0,0,0,.186,14.449,24.4,24.4,0,0,0,1.549,4.114c.339.677.66,1.371,1.024,2.057l1.261,2.006a28.009,28.009,0,0,0,17.048,11.452,27.679,27.679,0,0,0,11.647.051,28.212,28.212,0,0,0,11.148-5.163,27.153,27.153,0,0,0,8.084-9.929,27.679,27.679,0,0,0,2.776-12.765,28.22,28.22,0,0,0-3.132-12.121,27.273,27.273,0,0,0-7.567-9.125,28.094,28.094,0,0,0-20.019-5.722,30.38,30.38,0,0,0-8.761,2.421,27.933,27.933,0,0,0-11.063,9.192.085.085,0,0,1-.093.042l-11.943-1.422,11.969,1.21-.1.051a27.789,27.789,0,0,1,11.105-9.311,30.024,30.024,0,0,1,8.829-2.522,28.4,28.4,0,0,1,20.315,5.739,27.535,27.535,0,0,1,7.694,9.252,28.432,28.432,0,0,1,3.191,12.307,28.111,28.111,0,0,1-2.81,12.968,27.611,27.611,0,0,1-8.219,10.081,28.669,28.669,0,0,1-11.326,5.231,27.933,27.933,0,0,1-11.85-.076,28.237,28.237,0,0,1-17.208-11.6l-1.27-2.031c-.364-.694-.686-1.405-1.033-2.091a24.848,24.848,0,0,1-1.54-4.165,27.874,27.874,0,0,1-.1-14.584l.2.076h0a.118.118,0,0,1-.152.042h0Z",
    transform: "translate(-267.43 -159.953)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_210",
    "data-name": "Path 210",
    d: "M296.343,181.429a2.616,2.616,0,0,1,0,.389V182.9c0,.982,0,2.345.051,4.071,0,3.513.059,8.465.1,14.39l-.195-.195h19.917c.051-.051-.415.415-.22.212h0V181.463l.186.195-14.39-.1-4.071-.042h-.076l4.021-.051,14.5-.093h.195v20h0c.2-.195-.262.279-.22.229H296.03v-.229c0-5.976.068-10.962.093-14.5,0-1.693,0-3.064.051-4.029v-1.05A1.5,1.5,0,0,1,296.343,181.429Z",
    transform: "translate(-271.822 -163.242)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_211",
    "data-name": "Path 211",
    d: "M314.851,185.328c.288.229-2.387,4.088-5.984,8.625-.711.906-1.414,1.769-2.065,2.539l-.423.516-.474-.432c-3.115-2.8-5.223-4.952-5.036-5.172s2.632,1.557,5.857,4.232l-.906.085c.618-.846,1.3-1.693,2.015-2.59C311.423,188.6,314.572,185.108,314.851,185.328Z",
    transform: "translate(-272.563 -163.848)",
    fill: "#5796ff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompleted);
export default __webpack_public_path__ + "static/media/Completed.99483a7a28f6ecbaf2e5d88536d24ebb.svg";
export { ForwardRef as ReactComponent };